import type { WavespeedSpeechModelConfig } from '../types';

export const minimaxConfigs: Record<string, WavespeedSpeechModelConfig> = {
  'minimax-music-2.6': {
    // https://wavespeed.ai/zh-CN/models/minimax/music-2.6
    apiPath: '/minimax/music-2.6',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      return {
        prompt: text,
        lyrics: providerOptions?.lyrics || '',
        //  模式
        is_instrumental:
          typeof providerOptions?.is_instrumental === 'boolean'
            ? providerOptions.is_instrumental
            : false,
        // 可选参数
        bitrate: typeof providerOptions?.bitrate === 'number' ? providerOptions.bitrate : 256000,
        sample_rate: typeof providerOptions?.sample_rate === 'number' ? providerOptions.sample_rate : 44100,
      };
    },
  },
  'minimax-music-3.0': {
    // https://wavespeed.ai/zh-CN/models/minimax/music-3.0
    apiPath: '/minimax/music-3.0',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      const lyrics = providerOptions?.lyrics || '';
      return {
        prompt: text,
        lyrics: lyrics,
        //  模式
        is_instrumental:
          typeof providerOptions?.is_instrumental === 'boolean'
            ? providerOptions.is_instrumental
            : false,
        lyrics_optimizer:
          typeof providerOptions?.lyrics_optimizer === 'boolean'
            ? providerOptions.lyrics_optimizer
            : !lyrics,
        // 可选参数
        bitrate: typeof providerOptions?.bitrate === 'number' ? providerOptions.bitrate : 256000,
        sample_rate: typeof providerOptions?.sample_rate === 'number' ? providerOptions.sample_rate : 44100,
      };
    },
  },
  'minimax-music-cover': {
    // https://wavespeed.ai/zh-CN/models/minimax/music-cover
    apiPath: '/minimax/music-cover',
    enableTranslation: false,
    buildInput: ({ text, audioUrls }) => {
      return {
        prompt: text,
        // 音频 URL
        audio: audioUrls?.[0],
      };
    },
  },
  'minimax-speech-2.8-turbo': {
    // https://wavespeed.ai/zh-CN/models/minimax/speech-2.8-turbo
    apiPath: '/minimax/speech-2.8-turbo',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      return {
        text: text,
        voice_id:
          typeof providerOptions?.voice_id === 'string' && providerOptions.voice_id
            ? providerOptions.voice_id
            : voice,
        // 可选参数
        speed: typeof providerOptions?.speed === 'number' ? providerOptions.speed : 1,
        volume: typeof providerOptions?.volume === 'number' ? providerOptions.volume : 1,
        pitch: typeof providerOptions?.pitch === 'number' ? providerOptions.pitch : 0,
        emotion: typeof providerOptions?.emotion === 'string' ? providerOptions.emotion : 'happy',
        sample_rate: typeof providerOptions?.sample_rate === 'number' ? providerOptions.sample_rate : 32000,
        bitrate: typeof providerOptions?.bitrate === 'number' ? providerOptions.bitrate : 128000,
        channel: typeof providerOptions?.channel === 'string' ? providerOptions.channel : '1',
        format: typeof providerOptions?.format === 'string' ? providerOptions.format : 'mp3',
        language_boost: typeof providerOptions?.language_boost === 'string' ? providerOptions.language_boost : 'auto',
        english_normalization:
          typeof providerOptions?.english_normalization === 'boolean'
            ? providerOptions.english_normalization
            : false,
        // system
        pronunciation_dict: undefined,
      };
    },
  },
  'minimax-speech-2.8-hd': {
    // https://wavespeed.ai/zh-CN/models/minimax/speech-2.8-hd
    apiPath: '/minimax/speech-2.8-hd',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      return {
        text: text,
        voice_id:
          typeof providerOptions?.voice_id === 'string' && providerOptions.voice_id
            ? providerOptions.voice_id
            : voice,
        // 可选参数
        speed: typeof providerOptions?.speed === 'number' ? providerOptions.speed : 1,
        volume: typeof providerOptions?.volume === 'number' ? providerOptions.volume : 1,
        pitch: typeof providerOptions?.pitch === 'number' ? providerOptions.pitch : 0,
        emotion: typeof providerOptions?.emotion === 'string' ? providerOptions.emotion : 'happy',
        sample_rate: typeof providerOptions?.sample_rate === 'number' ? providerOptions.sample_rate : 32000,
        bitrate: typeof providerOptions?.bitrate === 'number' ? providerOptions.bitrate : 128000,
        channel: typeof providerOptions?.channel === 'string' ? providerOptions.channel : '1',
        format: typeof providerOptions?.format === 'string' ? providerOptions.format : 'mp3',
        language_boost: typeof providerOptions?.language_boost === 'string' ? providerOptions.language_boost : 'auto',
        english_normalization:
          typeof providerOptions?.english_normalization === 'boolean'
            ? providerOptions.english_normalization
            : false,
        // system
        pronunciation_dict: undefined,
      };
    },
  },
  'minimax-voice-clone': {
    // https://wavespeed.ai/zh-CN/models/minimax/voice-clone
    apiPath: '/minimax/voice-clone',
    enableTranslation: false,
    buildInput: ({ text, voice, audioUrls, providerOptions }) => {
      return {
        text: text,
        custom_voice_id: providerOptions?.lyrics || '',
        // 音频 URL
        audio: audioUrls?.[0],
        // 可选参数
        model: 'speech-2.8-hd',
        need_noise_reduction: providerOptions?.need_noise_reduction ?? false,
        need_volume_normalization: providerOptions?.need_volume_normalization ?? false,
        accuracy: typeof providerOptions?.accuracy === 'number' ? providerOptions.accuracy : 0.7,
        language_boost: undefined,
      };
    },
  },
};